import { useParams, Navigate } from "react-router";

import { views } from "./registry";

/*
 * Entry point for the `/view/:viewId` route tree.
 *
 * Unlike `Layout`, this component intentionally renders no app chrome. It looks
 * up `viewId` in the registry and hands off rendering to the matched view,
 * which owns its own layout. Unknown views fall back to the app root.
 */
export const View = () => {
  const { viewId } = useParams();

  const ViewComponent = views[viewId];

  if (!ViewComponent) {
    return <Navigate to="/" replace />;
  }

  return <ViewComponent />;
};
